module.exports = __webpack_public_path__ + "static/media/Jeronivosh.eb9b3537.jpg";